import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AsistenteEnLineaUtils } from '../../utils/asistente-en-linea.utils';
import { VentanaUtils } from '../../utils/ventana.utils';
import { LocalStorageService } from '../../services/local-storage.service';
import { MatDialog } from '@angular/material/dialog';
import { HandlerType } from '../../models/HandlerType';
import { Contexto } from '../../models/contexto';
import { FormElements } from '../../models/FormElements';
import { MailService } from '../asistencia-mail/services/mail.service';
import { InformModalComponent } from '../inform-modal/inform-modal.component';

@Component({
  selector: 'app-asistente-ventana',
  templateUrl: './asistente-ventana.component.html',
  styleUrls: ['./asistente-ventana.component.scss']
})
export class AsistenteVentanaComponent implements OnInit {

  @Input() handlerType: HandlerType;
  @Input() renderChat: boolean;
  @Input() renderEmail: boolean;
  @Input() renderTramite: boolean;
  @Input() renderMenuArbol: boolean;
  @Input() ctx: Contexto;
  @Input() formElements: FormElements;
  @Output() renderMenuArbolEmitter = new EventEmitter<Object>();
  @Output() switchHandlerEmitter = new EventEmitter<Object>();
  @Output() changeContextDataEmitter = new EventEmitter<Object>();

  public minimized = false;

  nroEmpresa: string;
  nroContribuyente: string;

  constructor(public utils: AsistenteEnLineaUtils,
    public dialog: MatDialog,
    public window: VentanaUtils,
    private localstorage: LocalStorageService,
    public rest: MailService) {


  }

  ngOnInit() {
    // Se carga los datos Personales y de empresa para desplegar info en el cabezal de la ventana
    if (this.ctx.datosEmpresa) {
      this.nroEmpresa = this.ctx.datosEmpresa.nroEmpresa;
      this.nroContribuyente = this.ctx.datosEmpresa.nroContribuyente;
    }
  }

  closeWindows() {
    this.ctx.idNodo = undefined;
    this.window.close.emit();
    if (this.ctx.historialMenus && this.ctx.historialMenus.length > 0) {
      this.ctx.idMenu = this.ctx.historialMenus[0];
      this.ctx.idAsistente = Number(this.ctx.idMenu);
      this.ctx.historialMenus = [this.ctx.idMenu];
    }
    // nos aseguramos de que cuando se cierre la ventana del submit vuelva al menu arbol 
    // si el formulario se llamo desde ese lugar; esto es especifico para la interaccion menu y formulario
    // Escenario: se cierra desde formulario de asistencia
    if (this.ctx.navigationHistory.codAsistente) {
      // Es accedio al formulario desde otro servicio (ej: menu arbol)
      this.ctx.codAsistente = this.ctx.navigationHistory.codAsistente;
      this.ctx.navigationHistory.codAsistente = undefined;
      if (this.ctx.navigationHistory.idMenu) {
        this.ctx.idMenu = this.ctx.navigationHistory.idMenu;
        this.ctx.idFormAsociado = this.ctx.navigationHistory.idFormAsociado;

        this.ctx.navigationHistory.idMenu = undefined;
        this.ctx.navigationHistory.idFormAsociado = undefined;
      }
      this.emitChangeContextDataEmitter({ idServicio: this.ctx.idServicio, codAsistente: this.ctx.codAsistente, idMenu: this.ctx.idMenu, idFormAsociado: this.ctx.idFormAsociado });
    }

  }

  minimizarMaximizar() {
    if (this.minimized) {
      this.maxWindows();
    } else {
      this.minWindows();
    }
  }

  minWindows() {
    this.minimized = true;
    this.localstorage.setWindowStatus('min');
    this.toggleRecaptchaBadge(false);
    this.window.minimizarVentana();
  }

  toggleRecaptchaBadge(show: boolean): void {
    const badge = document.querySelector('.grecaptcha-badge') as HTMLElement;
    if (badge) {
      badge.style.visibility = show ? 'visible' : 'hidden';
      badge.style.opacity = show ? '1' : '0';
    }
  }

  maxWindows() {
    this.minimized = false;
    this.localstorage.setWindowStatus('max');
    this.window.maximizarVentana(this.renderChat);
    if (this.renderChat) {
      this.window.resetStyleNewMessage();
    }
    this.toggleRecaptchaBadge(true);
  }

  emitRenderMenuArbol(event) {
    this.renderMenuArbolEmitter.emit(event);
  }

  emitSwitchHandlerEmitter(event) {
    this.switchHandlerEmitter.emit(event);
  }

  emitChangeContextDataEmitter(event) {
    this.changeContextDataEmitter.emit(event);
  }

  getNroEmpresaDecorator(): string {
    let toDisplay = this.nroEmpresa ? this.nroEmpresa.replace(/^0+/, '') : "";
    return toDisplay;
  }

  getNroContribuyenteDecorator(): string {
    let toDisplay = this.nroContribuyente ? this.nroContribuyente.replace(/^0+/, '') : "";
    return toDisplay;
  }

  getDescripcionAportacion(): string {
    let toDisplay = this.ctx.datosEmpresa && this.ctx.datosEmpresa.codigoAportacion ? this.utils.getDescripcionAportacion(this.ctx.datosEmpresa.codigoAportacion) : "";
    return toDisplay;
  }


}
